import displayError from '@/api/errors/errorResponse'
import { Button } from '@/components/ui/common/Button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger
} from '@/components/ui/dialog/Dialog'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import {
  editDisplayService,
  savedDisplaysService
} from '@/api/services/displays/displaysService'
import { ScrollArea } from '@/components/ui/common/ScrollArea'
import { useState } from 'react'

function DisplayPick({ id }: { id: string }) {
  const [open, setOpen] = useState(false)

  const { data } = useQuery({
    queryKey: ['displays'],
    queryFn: () => savedDisplaysService(1, 99999),
    select: (data) => {
      if (data.success) {
        return data.data
      }
      return undefined
    }
  })

  const queryClient = useQueryClient()

  const { mutate } = useMutation({
    mutationFn: ({ displayId, name }: { displayId: string; name: string }) =>
      editDisplayService(displayId, { advertisementId: id, name }),
    onSuccess: async (res) => {
      if (!res.success) return displayError(res)
      setOpen(false)
      await queryClient.invalidateQueries({ queryKey: ['displays'] })
    }
  })

  return (
    <Dialog onOpenChange={setOpen} open={open}>
      <DialogTrigger asChild>
        <Button>Wybierz wyświetlacz</Button>
      </DialogTrigger>
      <DialogContent
        aria-describedby="Usuń wyświetlacz"
        aria-description="Usuń wyświetlacz"
      >
        <DialogHeader>
          <DialogTitle>Wybierz wyświetlacz</DialogTitle>
        </DialogHeader>
        <ScrollArea className="h-72 w-full rounded-md border border-border">
          <div className="flex flex-col gap-2 p-2">
            {data?.items.map((item) => (
              <div
                className="flex w-full items-center justify-between rounded-md border border-border p-2"
                key={item.id}
              >
                <span>{item.name}</span>
                <Button
                  onClick={() => {
                    mutate({
                      displayId: item.id,
                      name: item.name
                    })
                  }}
                  variant={'outline'}
                >
                  Wybierz
                </Button>
              </div>
            ))}
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  )
}

export default DisplayPick
